/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable max-lines */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect } from 'react'
import {
  Box,
  Text,
  FloatingInput,
  IcoMoon,
  ArrowDownIcon,
  QuestionIcon,
} from '@usap/uicomponents'
import { getError, outsideClickHandler } from '@usap/core'
import useIsWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import { StyledErrorText } from '../Checkout/SignInWmo.css'

const FormField = ({
  value: propValue,
  label,
  name,
  updateForm = () => {},
  type = 'input',
  error,
  tooltip = false,
  tooltipLabel = '',
  useLocalState = true,
  errorLeftPadding = 'medium',
  maxAllowedLength,
  showInlineLengthCheck = false,
  isCheckOutSignInWmo = false,
  ...rest
}) => {
  const [value, setValue] = useState(propValue)

  const [showToolTip, setShowToolTip] = useState(false)

  const [localError, setLocalError] = useState('')

  const [valueLength, setValueLength] = useState(0)

  const updateError = (nameProp, valueProps, setState = false) => {
    const errorForSingleInstance = getError(nameProp, valueProps)
    if (setState) {
      setValue(valueProps)
    }
    return errorForSingleInstance
      ? setLocalError(errorForSingleInstance)
      : setLocalError('')
  }
  const isWmoEnabled = useIsWmoEnabled()
  useEffect(() => {
    if (localError || error) {
      updateError(name, propValue, true)
      updateForm({ target: { name, value: propValue } })
    }
  }, [propValue])

  const focusOnField = id => {
    setTimeout(() => {
      const elem = document.getElementById(id)
      if (elem) elem.focus()
    }, 300)
  }

  return (
    <Box style={{ position: 'relative' }}>
      {showToolTip && (
        <Box
          id="tooltiptext"
          align="center"
          justify="center"
          width="276px"
          height="40px"
          border={{ size: '1px', color: '#E0E0E0', side: 'all' }}
          background="white"
          style={{
            position: 'absolute',
            top: -28,
            right: tooltip && (useLocalState ? value : propValue) ? 16 : -8,
            zIndex: 9,
            borderRadius: '4px',
            boxShadow: '1px 2px 5px 1px rgba(3, 3, 3, 0.2)',
          }}
        >
          <Box style={{ fontSize: '12px' }}>{tooltipLabel}</Box>
          <Box
            style={{
              position: 'absolute',
              bottom: -22,
              right: 12,
            }}
          >
            <IcoMoon icon={ArrowDownIcon} color="white" size="40px" />
          </Box>
        </Box>
      )}
      <FloatingInput
        placeholder={label}
        label={label}
        id={name}
        defaultValue={propValue}
        key={propValue}
        name={name}
        onBlur={event => {
          updateError(name, event.target.value)
          updateForm(event)
          if (showInlineLengthCheck) setValueLength(0)
        }}
        type={type}
        onChange={e => {
          if (useLocalState) setValue(e.target.value)
          if (showInlineLengthCheck) { setValueLength((e.target.value || '').length) }
        }}
        onFocus={e => {
          if (showInlineLengthCheck) { setValueLength((e.target.value || '').length) }
        }}
        cross={useLocalState ? value : propValue}
        resetClick={event => {
          // eslint-disable-next-line no-param-reassign
          event.target.name = name
          // eslint-disable-next-line no-param-reassign
          event.target.value = ''
          updateForm(event)
          if (useLocalState) {
            setValue('')
          }
          focusOnField(name)
        }}
        tooltip={tooltip}
        isWmoEnabled={isWmoEnabled}
        isCheckOutSignInWmo={isCheckOutSignInWmo}
        hasError={isCheckOutSignInWmo && (localError || error)}
        {...rest}
      />
      {tooltip ? (
        <div
          id="tooltipicon"
          style={{
            position: 'absolute',
            top: 23,
            right: tooltip && (useLocalState ? value : propValue) ? 40 : 16,
            cursor: 'pointer',
          }}
        >
          <IcoMoon
            icon={QuestionIcon}
            size="20px"
            color="#b2b2b2"
            onClick={e => {
              e.stopPropagation()
              outsideClickHandler(showToolTip, ['tooltipicon'], () => {
                setShowToolTip(false)
              })
              setShowToolTip(!showToolTip)
            }}
          />
        </div>
      )
        : ''}
      {valueLength === 0 && (error || localError) && isWmoEnabled ? (
        <StyledErrorText>{localError || error}</StyledErrorText>
      ) : (
        <Text color="red" size="xsmall" margin={{ left: errorLeftPadding }}>
          {localError || error}
        </Text>
      )}
      {valueLength !== 0 && (
        <Text color="dark-1" size="xsmall" margin={{ left: errorLeftPadding }}>
          Maximum
          {' '}
          {maxAllowedLength}
          {' '}
          characters&nbsp;(
          <font
            color={
              Number(maxAllowedLength) >= Number(valueLength)
                ? '#333333'
                : '#f44635'
            }
          >
            {Number(maxAllowedLength) - Number(valueLength)}
          </font>
          )
        </Text>
      )}
    </Box>
  )
}

export default FormField
